var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['bandcamp-album-player']},[_c('iframe',{style:({height: _vm.$config.bandCampPlayer.height}),attrs:{"seamless":"","src":_vm.makeBandCampPlayerUrl(_vm.album.id),"frameborder":"0"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3a8ffc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/album-player.vue
// module id = null
// module chunks = 